import Grid from "@mui/material/Grid";
import React, { useRef, useEffect, useState } from "react";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Header from "layouts/authentication/components/Header";
import { useMsal } from "@azure/msal-react";

const projectPDFs = {
  WhoDat: [
    "/forms/WhoDat/LeakEventForm/WDSLD-OP-FRM-00001%20(Rev%20K)%20Leak%20Detection%20Event%20Form.pdf",
  ],
  WhoDatREG: [
    "/forms/WhoDat/LeakEventForm/WDSLD-OP-FRM-00001%20(Rev%20K)%20Leak%20Detection%20Event%20Form.pdf",
  ],
  // Fixing ADV Role Key Naming and Mapping to the Same PDFs
  WhoDatADV: [
    "/forms/WhoDat/LeakEventForm/WDSLD-OP-FRM-00001%20(Rev%20K)%20Leak%20Detection%20Event%20Form.pdf",
  ],
};

function LeakEventResponseForm() {
  const iframeRef = useRef(null);
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const userRoles = activeAccount?.idTokenClaims?.roles || [];

  // Use selected role from local storage or default to the first available role
  const [selectedRole, setSelectedRole] = useState(
    localStorage.getItem("selectedRole") || userRoles[0] || ""
  );

  useEffect(() => {
    const storedRole = localStorage.getItem("selectedRole");
    if (storedRole && selectedRole !== storedRole) {
      setSelectedRole(storedRole);
    }
  }, []);

  // Get the PDF link based on the selected role
  const pdfLink = projectPDFs[selectedRole] || null;

  const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
      iframeRef.current.requestFullscreen().catch((err) => {
        alert(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
      });
    } else {
      document.exitFullscreen();
    }
  };

  return (
    <DashboardLayout>
      <Header title="Leak Event Response Form" />
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid item xs={true}>
          <DashboardNavbar />
        </Grid>
        <Grid item sx={{ marginTop: "2rem" }}>
          <MDButton color="info" onClick={toggleFullScreen}>
            Toggle Full Screen
          </MDButton>
        </Grid>
      </Grid>

      {pdfLink ? (
        <div style={{ position: "relative", paddingTop: "56.25%" }}>
          <iframe
            ref={iframeRef}
            title="Leak Event Response Form"
            src={pdfLink}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              border: "none",
            }}
          />
        </div>
      ) : (
        <p style={{ textAlign: "center", fontSize: "20px", fontWeight: "bold" }}>
          No PDFs Available for Your Selected Role
        </p>
      )}
    </DashboardLayout>
  );
}

export default LeakEventResponseForm;
